import React from 'react';
import { Preloader } from '../../../elements/Preloader';
import Styles from './AuthorizationSberIdFormHOCLoader.scss';

export const AuthorizationSberIdFormHOCLoader = () => (
  <div className={Styles.loader}>
    <Preloader />
  </div>
);
